<template>
    <div class="shimmer"></div>
</template>

<style scoped>
.shimmer {
    background: linear-gradient(to right, #eeeeee 0%, #dddddd 20%, #eeeeee 40%);
    background-size: 800px 100%;
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: shimmer;
    animation-timing-function: linear;
}

.dark .shimmer {
    background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.2) 20%,
        rgba(255, 255, 255, 0) 40%,
        rgba(255, 255, 255, 0) 100%
    );
    background-size: 800px 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: shimmer;
    animation-timing-function: linear;
}

@keyframes shimmer {
    0% {
        background-position: -800px 0;
    }

    100% {
        background-position: 800px 0;
    }
}
</style>
